var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "b-card",
        [
          _c("b-row", [_c("h3", [_vm._v("Transportadoras")])]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "primary" },
                      on: { click: _vm.addTransportadora }
                    },
                    [
                      _c("i", { staticClass: "fa fa-tasks" }),
                      _vm._v(" Nova\n                    Transportadora")
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { lg: "6" } },
                [
                  _c(
                    "b-form-group",
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "filter-input",
                              type: "search",
                              placeholder: "Buscar Transportadora"
                            },
                            model: {
                              value: _vm.filter,
                              callback: function($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { disabled: !_vm.filter },
                                  on: {
                                    click: function($event) {
                                      _vm.filter = ""
                                    }
                                  }
                                },
                                [_vm._v("Limpar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-table", {
                    attrs: {
                      items: _vm.transportadoras,
                      fields: _vm.colunas,
                      "current-page": _vm.currentPage,
                      "per-page": _vm.perPage,
                      filter: _vm.filter,
                      "filter-included-fields": _vm.filterOn,
                      stacked: "md",
                      "show-empty": "",
                      hover: ""
                    },
                    on: { filtered: _vm.onFiltered },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(editar)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.editar(row.item)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-edit" })]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { sm: "7", md: "6" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "fill",
                      size: "sm"
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "text-right" }, [
                _c("span", [
                  _vm._v(
                    "Total de Transportadoras: " +
                      _vm._s(_vm.transportadoras.length) +
                      " "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: { size: "xl", title: "Nova Transportadora" },
              scopedSlots: _vm._u([
                {
                  key: "modal-footer",
                  fn: function() {
                    return [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "sm" },
                          on: { click: _vm.SalvaTransport }
                        },
                        [
                          _c("i", { staticClass: "fa fa-save" }),
                          _vm._v("\n                    Salvar")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "danger", size: "sm" },
                          on: {
                            click: function($event) {
                              _vm.modalNovaTransportadora = false
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      )
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.modalNovaTransportadora,
                callback: function($$v) {
                  _vm.modalNovaTransportadora = $$v
                },
                expression: "modalNovaTransportadora"
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c("label", [_vm._v("Digite um código")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.codigo,
                        expression: "codigo"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.codigo },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.codigo = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("label", [_vm._v("Nome:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nome,
                        expression: "nome"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.nome },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.nome = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-10 mt-2" }, [
                  _c("label", [
                    _vm._v("Digite a URL "),
                    _c("small", [_vm._v("(endereço de rastreamento)")])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.url,
                        expression: "url"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.url },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.url = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Mensagem:")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mensagem,
                          expression: "mensagem"
                        }
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.mensagem },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.mensagem = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-061ed794", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061ed794","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/transportadora/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-061ed794","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/transportadora/List.vue
// module chunks = 2